import { gql } from '@apollo/client';

export const CUSTOMER_PROFILE_FIELDS = gql`
  fragment CustomerProfileFields on CustomerProfile {
    id
    first_name
    last_name
    full_name
    phone
    email
  }
`;

export const CUSTOMER_LOGIN_MUTATION = gql`
  ${CUSTOMER_PROFILE_FIELDS}
  mutation CustomerLogin($input: CustomerLoginInput!) {
    customerLogin(input: $input) {
      access_token
      refresh_token
      expires_in
      customer {
        ...CustomerProfileFields
      }
    }
  }
`;

export const CUSTOMER_LOGOUT_MUTATION = gql`
  mutation CustomerLogout($input: CustomerLogoutInput!) {
    customerLogout(input: $input) {
      ok
    }
  }
`;

export const ME_CUSTOMER_QUERY = gql`
  ${CUSTOMER_PROFILE_FIELDS}
  query MeCustomer {
    meCustomer {
      ...CustomerProfileFields
    }
  }
`;

export const MY_PETS_QUERY = gql`
  query MyPets {
    myPets {
      id
      name
      species
      breed
      color
      sex
      birth_date
      approximate_age_months
      weight_grams
    }
  }
`;

export const MY_PET_CLINICAL_HISTORY_QUERY = gql`
  query MyPetClinicalHistory($pet_id: ID!) {
    myPetClinicalHistory(pet_id: $pet_id) {
      id
      date
      visit_kind
      folio_number
      diagnosis_count
    }
  }
`;

export const MY_CLINICAL_VISIT_QUERY = gql`
  query MyClinicalVisit($visit_id: ID!) {
    myClinicalVisit(visit_id: $visit_id) {
      id
      date
      visit_kind
      folio_number
      veterinarian_name
      diagnoses {
        kind
        description
        is_primary
      }
      prescriptions {
        id
        status
        lines {
          drug_name
          dose
          dose_unit
          route
          frequency
          duration_days
          instructions
          is_controlled
        }
      }
    }
  }
`;

export const MY_PET_HOSPITALIZATIONS_QUERY = gql`
  query MyPetHospitalizations($pet_id: ID!) {
    myPetHospitalizations(pet_id: $pet_id) {
      id
      folio_number
      status
      admission_reason
      discharge_summary
      admitted_at
      discharged_at
      veterinarian_name
    }
  }
`;

export const MY_APPOINTMENTS_QUERY = gql`
  query MyAppointments($upcoming_only: Boolean) {
    myAppointments(upcoming_only: $upcoming_only) {
      id
      folio_number
      pet_id
      scheduled_start_at
      scheduled_end_at
      status
      appointment_kind
      veterinarian_name
      consulting_room_name
    }
  }
`;

export const AVAILABLE_VETERINARIANS_QUERY = gql`
  query AvailableVeterinarians($scheduled_start_at: DateTime!) {
    availableVeterinarians(scheduled_start_at: $scheduled_start_at) {
      id
      full_name
    }
  }
`;

export const CANCEL_MY_APPOINTMENT_REQUEST_MUTATION = gql`
  mutation CancelMyAppointmentRequest($appointment_id: ID!) {
    cancelMyAppointmentRequest(appointment_id: $appointment_id) {
      id
      status
    }
  }
`;

export const REQUEST_APPOINTMENT_MUTATION = gql`
  mutation RequestAppointment($input: RequestAppointmentInput!) {
    requestAppointment(input: $input) {
      id
      folio_number
      status
      scheduled_start_at
    }
  }
`;
